enum NoteEditingPermissions {
  CARE_NAVIGATOR_NOTES_EDITOR = "CareNavigatorNotesEditor"
}

export default NoteEditingPermissions;
